<app-rc-dialog-wrapper (closePopin)="close()">
  <div class="upload-logo-dialog-content">
    @if (!isLoading) {
      <div class="upload-logo">
        <h1 class="upload-logo__title rc-title-beta">
          <span i18n="@@title-upload-logo">Upload a logo</span>
        </h1>
        <p class="upload-logo__position-text" i18n="@@message-position-image">Position and size your logo</p>
        @if (!uploadSuccess) {
          <div class="upload-logo__circle" [class.is-failed]="uploadSizeFailed" (click)="inputEvent.click()">
            <em class="rc-icon rc-icon--upload" [class.is-failed]="uploadSizeFailed"></em>
          </div>
        } @else {
          <img class="upload-logo__image" [src]="imageUrl" alt="logo" />
        }
        <input
          class="upload-logo__choose-file-button"
          type="file"
          name="profile_pic"
          accept=".jpg, .jpeg, .png, .gif"
          (change)="onFileSelect($event)"
          #inputEvent
        />
        <rc-link
          data-qa="vs-account-page-clinic-upload-logo-popinlink-upload-logo"
          variant="secondary"
          size="large"
          iconname="document-image"
          iconposition="left"
          class="upload-logo__button-container"
          (click)="inputEvent.click()"
        >
          {{ 'action_upload-picture' | translateKey }}
        </rc-link>
        @if (!uploadSuccess) {
          <p class="upload-logo__maximum-text" i18n="@@message-file-size">Maximum size file: 2MB</p>
          <p class="upload-logo__extension-text" i18n="@@message-file-type">Allowed file type : JPEG, JPG, GIF, PNG</p>
        }
        @if (uploadSizeFailed) {
          <div class="upload-logo__error-message-container">
            <em class="upload-logo__error-message-container-image rc-icon rc-icon--cross"></em>
            <span class="upload-logo__error-message-container-text">{{ errorMessage }}</span>
          </div>
        }
        @if (uploadSuccess) {
          <div class="upload-logo__action-container">
            <rc-link data-qa="vs-upload-logo-popin-button-cancel" variant="secondary" size="large" (click)="close()">
              {{ 'action_cancel' | translateKey | titlecase }}
            </rc-link>
            <span class="rc-button__separator" i18n="@@action_separator">or</span>
            <rc-button data-qa="vs-upload-logo-popin-button-save-changes" (click)="submit()">
              {{ 'action_save-changes' | translateKey | titlecase }}
            </rc-button>
          </div>
        }
      </div>
    } @else {
      <div class="loader"></div>
    }
  </div>
</app-rc-dialog-wrapper>
